/* global CCP_WIDGET_URL */
import React, { useEffect, useRef, useState } from 'react'

const WidgetThemeGenerator = () => {
  const themeContainer = useRef(null)
  const [generatorScriptLoaded, setGeneratorScriptLoaded] = useState(false)

  useEffect(() => {
    const script = document.createElement("script")
    script.onload = () => setGeneratorScriptLoaded(true)
    script.src = `${CCP_WIDGET_URL}/themeGenerator.js`
    script.async = true
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    if(generatorScriptLoaded && themeContainer) {
      window.ccpThemeGenerator.renderGenerator(themeContainer.current)
    }
  }, [generatorScriptLoaded, themeContainer])


  return (
    <div ref={themeContainer} className="theme-generator__container" style={{ boxSizing: 'initial' }}/>
  )
}

export default WidgetThemeGenerator
